// Strings for the custom app workspace. Merged into `translations` so pages read them like any other key.
const en = {
    navDashboard: 'Dashboard',
    navCustomApps: 'Custom Apps',
    navFlavors: 'Flavors',
    navBuilds: 'Builds',
    workspaceEyebrow: 'Custom app workspace',
    primaryNavigation: 'Primary navigation',
    loading: 'Loading…',
    loadFailed: 'Could not load this page.',
    retry: 'Try again',
    refresh: 'Refresh',
    cancel: 'Cancel',
    back: 'Back',
    next: 'Next',
    none: 'None',
    optional: 'optional',

    statusLabel: {
        request_submitted: 'Request submitted',
        waiting_asset: 'Waiting for assets',
        design: 'Design',
        custom_development: 'Custom development',
        internal_review: 'Internal review',
        google_play_review: 'Google Play review',
        revision_requested: 'Revision requested',
        build_failed: 'Build failed',
        google_play_rejected: 'Google Play rejected',
        published: 'Published',
        rejected: 'Rejected',
    },
    reasonLabel: {
        asset_missing: 'Logo or icon missing',
        flavor_missing: 'No flavor linked',
        build_failed: 'Last build failed',
        waiting_asset: 'Waiting for assets',
        revision_requested: 'Revision requested',
        google_play_rejected: 'Rejected by Google Play',
        stale: 'No update for a while',
    },
    categoryLabel: {
        logo: 'Logo',
        icon: 'App icon',
        splash: 'Splash screen',
        guideline: 'Brand guideline',
        reference: 'Reference',
        other: 'Other file',
    },
    actionLabel: {
        custom_app_created: 'Request created',
        custom_app_updated: 'Details updated',
        status_changed: 'Status changed',
        asset_uploaded: 'File uploaded',
        comment_added: 'Comment added',
        flavor_linked: 'Flavor linked',
        flavor_unlinked: 'Flavor unlinked',
        build_started: 'Build started',
        build_success: 'Build succeeded',
        build_failed: 'Build failed',
        published: 'Published',
        notification_failed: 'Telegram notification failed',
    },
    errorCode: {
        invalid_status_transition: 'That status change is not allowed from the current status.',
        status_unchanged: 'The request already has this status.',
        publication_url_required: 'Save the Play Store link before publishing.',
        invalid_play_store_url: 'Use a link that starts with https://play.google.com/.',
        company_mismatch: 'That flavor belongs to another company.',
        mapping_required: 'Set this flavor\'s company on the Flavors page first.',
        flavor_not_found: 'That flavor no longer exists.',
        flavor_not_linked: 'That flavor is not linked to this request.',
        not_request_owner: 'Only the person who made the request can change it.',
        insufficient_role: 'Your role cannot do this.',
        file_too_large: 'That file is too large.',
        unsupported_file_type: 'That file type is not allowed.',
        invalid_attachment: 'An attachment does not belong to this request.',
        invalid_category: 'Choose a file type from the list.',
        company_not_found: 'The CRM does not know this company.',
        company_required: 'Choose a CRM company first.',
        crm_unavailable: 'The CRM did not respond. Try again in a moment.',
        build_in_progress: 'A build is already running.',
    },

    dashboardTitle: 'Dashboard',
    metricTotal: 'Total custom apps',
    attentionEyebrow: 'Work queue',
    attentionTitle: 'Needs attention',
    attentionEmpty: 'Nothing needs attention right now.',
    attentionCount: '{count} need attention',
    viewAllApps: 'View all custom apps',
    unmappedCompany: 'Company not set',

    listTitle: 'Custom Apps',
    startRequest: 'Start a request',
    searchApps: 'Search by app or company',
    searchAction: 'Search',
    filterAll: 'All',
    filterNew: 'New requests',
    filterInProgress: 'In progress',
    filterGoogleReview: 'Google review',
    filterPublished: 'Published',
    filterCompany: 'Company: {name}',
    clearCompanyFilter: 'Show all companies',
    noAppsTitle: 'No custom apps match this view.',
    noAppsHint: 'Change the filter, or start a new request.',
    pageOf: 'Page {page} of {total}',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    appRowCompany: 'Company',
    untitledApp: 'Untitled app',
    attentionBadge: 'Needs attention',

    wizardTitle: 'New custom app request',
    wizardEyebrow: 'Sales request',
    summaryTitle: 'Request summary',
    summaryEmpty: 'Not filled yet',
    summaryNote: 'The team is notified on Telegram as soon as you send the request. Files can be added later.',
    stepCompany: 'Company',
    stepApp: 'App details',
    stepAssets: 'Files',
    stepOf: 'Step {step} of {total}',
    companyHelp: 'Pick the school or institution from the CRM. Its name and ID are copied into the request.',
    companySearch: 'Search CRM company',
    companySearchAction: 'Search',
    companySelected: 'Selected company',
    companyNone: 'No CRM company matches that search.',
    companyChooseFirst: 'Choose a company to continue.',
    appNameLabel: 'App name',
    packageNameLabel: 'Package name',
    packageNameHint: 'Example: id.co.school.app. Leave empty if the developer sets it.',
    primaryColorLabel: 'Primary color',
    secondaryColorLabel: 'Secondary color',
    colorHint: 'Use #RRGGBB, for example #0054E6.',
    bankLabel: 'Bank',
    bankHint: 'Separate several banks with commas.',
    notesLabel: 'Notes for the team',
    notesPlaceholder: 'Anything the designer or developer should know: reference apps, special configuration, deadlines.',
    appNameRequired: 'Enter the app name.',
    invalidPackage: 'Package name must look like id.co.school.app.',
    invalidColor: 'Color must be #RRGGBB.',
    filesHelp: 'Attach what you already have. Missing files can be added later from the request page.',
    chooseFile: 'Choose file',
    changeFile: 'Change file',
    noFileChosen: 'No file chosen',
    sendRequest: 'Send request',
    sendingRequest: 'Sending…',
    requestFailed: 'The request could not be sent.',
    filesFailedNotice: 'The request was created, but these files did not upload: {files}. Add them from the Files tab.',

    tabOverview: 'Overview',
    tabAssets: 'Files',
    tabDiscussion: 'Discussion',
    tabBuild: 'Build',
    tabPublication: 'Publication',
    activityTitle: 'Activity',
    activityEmpty: 'No activity yet.',
    stepperLabel: 'Request progress',
    stepCurrent: 'current',
    stepDone: 'done',
    stepBlocked: 'stuck',
    stepTodo: 'not started',
    company: 'Company',
    companyId: 'Company ID',
    packageName: 'Package name',
    banks: 'Bank',
    colors: 'Colors',
    requestedBy: 'Requested by',
    createdAt: 'Created',
    updatedAt: 'Last update',
    notes: 'Notes',
    noNotes: 'No notes.',
    notSet: 'Not set',
    statusSection: 'Status',
    moveTo: 'Move to',
    chooseStatus: 'Choose a status',
    noMoves: 'Your role cannot change the status from here.',
    updateStatus: 'Update status',
    statusUpdated: 'Status updated.',

    uploadFile: 'Upload file',
    uploadingFile: 'Uploading…',
    fileType: 'File type',
    noFiles: 'No files yet.',
    noLogoYet: 'No logo or icon yet. The team needs one before development starts.',
    fileUploaded: 'File uploaded.',
    uploadedBy: 'Uploaded by {name}',
    downloadFile: 'Download {name}',

    writeUpdate: 'Write an update',
    attachFile: 'Attach a file',
    sendUpdate: 'Send update',
    noMessages: 'No messages yet. Start the conversation here.',
    commentSent: 'Update sent.',
    attachments: 'Attachments',
    teamMember: 'Team member',

    linkedFlavors: 'Linked flavors',
    noFlavorLinked: 'No flavor is linked yet.',
    flavorsOfCompany: 'Flavors of this company',
    flavorsOfOthers: 'Flavors of other companies',
    noMatchingFlavor: 'No flavor belongs to this company yet. Set a flavor\'s company on the Flavors page.',
    linkFlavor: 'Link',
    unlinkFlavor: 'Unlink',
    buildFlavor: 'Build this flavor',
    flavorLinked: 'Flavor linked.',
    flavorUnlinked: 'Flavor unlinked.',
    mappingStatusLabel: 'Company mapping',
    lastBuild: 'Last build',
    noBuildYet: 'No build has run for this request.',
    openBuild: 'Open build log',
    buildForCustomApp: 'This build is recorded on the custom app\'s activity.',
    openCustomApp: 'Open custom app',

    playStoreUrl: 'Play Store link',
    releaseNotes: 'Release notes',
    saveLink: 'Save link and notes',
    publishApp: 'Publish app',
    publishHelp: 'Publishing marks the request as published and sends the Play Store link to the team on Telegram.',
    publicationSaved: 'Publication details saved.',
    publishedOn: 'Published {date}',
    openPlayStore: 'Open on Google Play',
    publicationReadOnly: 'Only developers and admins can edit publication details.',
    notPublishedYet: 'Not published yet.',

    companiesFailed: 'Could not search CRM companies.',

    mappingLabel: {
        connected: 'Company connected',
        mapping_required: 'Company needs checking',
        not_found: 'No company set',
        invalid: 'CRM check failed',
        unchecked: 'Not checked yet',
    },
    chooseFromCrm: 'Choose from CRM',
    hideCrmPicker: 'Close CRM search',
    checkCompanies: 'Check companies with CRM',
    checkingCompanies: 'Checking…',
    companiesChecked: 'Company check finished.',
    checkCompaniesFailed: 'The company check did not finish. Try again.',
    flavorChecks: {
        flavorName: 'Flavor name: start with a lowercase letter, then letters, numbers or underscores.',
        applicationName: 'Application name: required, without quotes, backslashes or $.',
        packageName: 'Package name must look like id.co.school.app.',
        versionCode: 'Version code must be a whole number from 1 up.',
        versionName: 'Version name: letters, numbers, dots, dashes or underscores.',
        primary: 'Primary color must be #RRGGBB.',
        secondary: 'Secondary color must be #RRGGBB.',
        serverKey: 'Server key must be 1 to 3 digits.',
        keystoreName: 'Keystore name: letters, numbers, dots, dashes or underscores.',
        keyAlias: 'Key alias: letters, numbers, dots, dashes or underscores.',
        password: 'Password is required and cannot contain quotes, backslashes or $.',
    },
    flavorChecksTitle: 'Fix these before saving:',
};

const id = {
    navDashboard: 'Dashboard',
    navCustomApps: 'Custom App',
    navFlavors: 'Flavor',
    navBuilds: 'Build',
    workspaceEyebrow: 'Ruang kerja custom app',
    primaryNavigation: 'Navigasi utama',
    loading: 'Memuat…',
    loadFailed: 'Halaman ini tidak bisa dimuat.',
    retry: 'Coba lagi',
    refresh: 'Muat ulang',
    cancel: 'Batal',
    back: 'Kembali',
    next: 'Lanjut',
    none: 'Tidak ada',
    optional: 'opsional',

    statusLabel: {
        request_submitted: 'Request dikirim',
        waiting_asset: 'Menunggu aset',
        design: 'Desain',
        custom_development: 'Pengembangan custom',
        internal_review: 'Review internal',
        google_play_review: 'Review Google Play',
        revision_requested: 'Perlu revisi',
        build_failed: 'Build gagal',
        google_play_rejected: 'Ditolak Google Play',
        published: 'Terbit',
        rejected: 'Ditolak',
    },
    reasonLabel: {
        asset_missing: 'Logo atau ikon belum ada',
        flavor_missing: 'Belum ada flavor terhubung',
        build_failed: 'Build terakhir gagal',
        waiting_asset: 'Menunggu aset',
        revision_requested: 'Perlu revisi',
        google_play_rejected: 'Ditolak Google Play',
        stale: 'Lama tidak ada pembaruan',
    },
    categoryLabel: {
        logo: 'Logo',
        icon: 'Ikon aplikasi',
        splash: 'Splash screen',
        guideline: 'Panduan brand',
        reference: 'Referensi',
        other: 'File lain',
    },
    actionLabel: {
        custom_app_created: 'Request dibuat',
        custom_app_updated: 'Detail diubah',
        status_changed: 'Status berubah',
        asset_uploaded: 'File diunggah',
        comment_added: 'Komentar ditambahkan',
        flavor_linked: 'Flavor dihubungkan',
        flavor_unlinked: 'Flavor dilepas',
        build_started: 'Build dimulai',
        build_success: 'Build berhasil',
        build_failed: 'Build gagal',
        published: 'Diterbitkan',
        notification_failed: 'Notifikasi Telegram gagal',
    },
    errorCode: {
        invalid_status_transition: 'Perubahan status itu tidak diizinkan dari status saat ini.',
        status_unchanged: 'Request sudah berstatus ini.',
        publication_url_required: 'Simpan link Play Store sebelum menerbitkan.',
        invalid_play_store_url: 'Gunakan link yang diawali https://play.google.com/.',
        company_mismatch: 'Flavor itu milik company lain.',
        mapping_required: 'Atur company flavor ini di halaman Flavor dulu.',
        flavor_not_found: 'Flavor itu sudah tidak ada.',
        flavor_not_linked: 'Flavor itu tidak terhubung ke request ini.',
        not_request_owner: 'Hanya pembuat request yang bisa mengubahnya.',
        insufficient_role: 'Role Anda tidak bisa melakukan ini.',
        file_too_large: 'File itu terlalu besar.',
        unsupported_file_type: 'Jenis file itu tidak diizinkan.',
        invalid_attachment: 'Ada lampiran yang bukan milik request ini.',
        invalid_category: 'Pilih jenis file dari daftar.',
        company_not_found: 'CRM tidak mengenal company ini.',
        company_required: 'Pilih company CRM dulu.',
        crm_unavailable: 'CRM tidak merespons. Coba lagi sebentar lagi.',
        build_in_progress: 'Sedang ada build yang berjalan.',
    },

    dashboardTitle: 'Dashboard',
    metricTotal: 'Total custom app',
    attentionEyebrow: 'Antrean kerja',
    attentionTitle: 'Perlu perhatian',
    attentionEmpty: 'Saat ini tidak ada yang perlu perhatian.',
    attentionCount: '{count} perlu perhatian',
    viewAllApps: 'Lihat semua custom app',
    unmappedCompany: 'Company belum diatur',

    listTitle: 'Custom App',
    startRequest: 'Buat request',
    searchApps: 'Cari nama aplikasi atau company',
    searchAction: 'Cari',
    filterAll: 'Semua',
    filterNew: 'Request baru',
    filterInProgress: 'Dikerjakan',
    filterGoogleReview: 'Review Google',
    filterPublished: 'Terbit',
    filterCompany: 'Company: {name}',
    clearCompanyFilter: 'Tampilkan semua company',
    noAppsTitle: 'Tidak ada custom app di tampilan ini.',
    noAppsHint: 'Ubah filter, atau buat request baru.',
    pageOf: 'Halaman {page} dari {total}',
    previousPage: 'Halaman sebelumnya',
    nextPage: 'Halaman berikutnya',
    appRowCompany: 'Company',
    untitledApp: 'Aplikasi tanpa nama',
    attentionBadge: 'Perlu perhatian',

    wizardTitle: 'Request custom app baru',
    wizardEyebrow: 'Request sales',
    summaryTitle: 'Ringkasan request',
    summaryEmpty: 'Belum diisi',
    summaryNote: 'Tim langsung diberi tahu lewat Telegram begitu request dikirim. File bisa ditambahkan nanti.',
    stepCompany: 'Company',
    stepApp: 'Detail aplikasi',
    stepAssets: 'File',
    stepOf: 'Langkah {step} dari {total}',
    companyHelp: 'Pilih sekolah atau lembaga dari CRM. Nama dan ID-nya disalin ke request.',
    companySearch: 'Cari company CRM',
    companySearchAction: 'Cari',
    companySelected: 'Company terpilih',
    companyNone: 'Tidak ada company CRM yang cocok.',
    companyChooseFirst: 'Pilih company untuk melanjutkan.',
    appNameLabel: 'Nama aplikasi',
    packageNameLabel: 'Package name',
    packageNameHint: 'Contoh: id.co.sekolah.app. Kosongkan jika developer yang menentukan.',
    primaryColorLabel: 'Warna utama',
    secondaryColorLabel: 'Warna sekunder',
    colorHint: 'Gunakan #RRGGBB, misalnya #0054E6.',
    bankLabel: 'Bank',
    bankHint: 'Pisahkan beberapa bank dengan koma.',
    notesLabel: 'Catatan untuk tim',
    notesPlaceholder: 'Hal yang perlu diketahui desainer atau developer: aplikasi referensi, konfigurasi khusus, tenggat.',
    appNameRequired: 'Isi nama aplikasi.',
    invalidPackage: 'Package name harus berbentuk id.co.sekolah.app.',
    invalidColor: 'Warna harus berformat #RRGGBB.',
    filesHelp: 'Lampirkan yang sudah ada. File yang belum ada bisa ditambah nanti dari halaman request.',
    chooseFile: 'Pilih file',
    changeFile: 'Ganti file',
    noFileChosen: 'Belum ada file',
    sendRequest: 'Kirim request',
    sendingRequest: 'Mengirim…',
    requestFailed: 'Request tidak bisa dikirim.',
    filesFailedNotice: 'Request sudah dibuat, tetapi file ini gagal diunggah: {files}. Tambahkan dari tab File.',

    tabOverview: 'Ringkasan',
    tabAssets: 'File',
    tabDiscussion: 'Diskusi',
    tabBuild: 'Build',
    tabPublication: 'Publikasi',
    activityTitle: 'Aktivitas',
    activityEmpty: 'Belum ada aktivitas.',
    stepperLabel: 'Progres request',
    stepCurrent: 'sekarang',
    stepDone: 'selesai',
    stepBlocked: 'tertahan',
    stepTodo: 'belum mulai',
    company: 'Company',
    companyId: 'ID company',
    packageName: 'Package name',
    banks: 'Bank',
    colors: 'Warna',
    requestedBy: 'Diminta oleh',
    createdAt: 'Dibuat',
    updatedAt: 'Pembaruan terakhir',
    notes: 'Catatan',
    noNotes: 'Tidak ada catatan.',
    notSet: 'Belum diisi',
    statusSection: 'Status',
    moveTo: 'Pindah ke',
    chooseStatus: 'Pilih status',
    noMoves: 'Role Anda tidak bisa mengubah status dari sini.',
    updateStatus: 'Ubah status',
    statusUpdated: 'Status diubah.',

    uploadFile: 'Unggah file',
    uploadingFile: 'Mengunggah…',
    fileType: 'Jenis file',
    noFiles: 'Belum ada file.',
    noLogoYet: 'Belum ada logo atau ikon. Tim membutuhkannya sebelum pengembangan dimulai.',
    fileUploaded: 'File diunggah.',
    uploadedBy: 'Diunggah oleh {name}',
    downloadFile: 'Unduh {name}',

    writeUpdate: 'Tulis pembaruan',
    attachFile: 'Lampirkan file',
    sendUpdate: 'Kirim pembaruan',
    noMessages: 'Belum ada pesan. Mulai percakapan di sini.',
    commentSent: 'Pembaruan terkirim.',
    attachments: 'Lampiran',
    teamMember: 'Anggota tim',

    linkedFlavors: 'Flavor terhubung',
    noFlavorLinked: 'Belum ada flavor yang terhubung.',
    flavorsOfCompany: 'Flavor milik company ini',
    flavorsOfOthers: 'Flavor milik company lain',
    noMatchingFlavor: 'Belum ada flavor milik company ini. Atur company flavor di halaman Flavor.',
    linkFlavor: 'Hubungkan',
    unlinkFlavor: 'Lepas',
    buildFlavor: 'Build flavor ini',
    flavorLinked: 'Flavor dihubungkan.',
    flavorUnlinked: 'Flavor dilepas.',
    mappingStatusLabel: 'Mapping company',
    lastBuild: 'Build terakhir',
    noBuildYet: 'Belum ada build untuk request ini.',
    openBuild: 'Buka log build',
    buildForCustomApp: 'Build ini dicatat di aktivitas custom app.',
    openCustomApp: 'Buka custom app',

    playStoreUrl: 'Link Play Store',
    releaseNotes: 'Catatan rilis',
    saveLink: 'Simpan link dan catatan',
    publishApp: 'Terbitkan aplikasi',
    publishHelp: 'Menerbitkan menandai request sebagai terbit dan mengirim link Play Store ke tim lewat Telegram.',
    publicationSaved: 'Detail publikasi disimpan.',
    publishedOn: 'Terbit {date}',
    openPlayStore: 'Buka di Google Play',
    publicationReadOnly: 'Hanya developer dan admin yang bisa mengubah detail publikasi.',
    notPublishedYet: 'Belum terbit.',

    companiesFailed: 'Company CRM tidak bisa dicari.',

    mappingLabel: {
        connected: 'Company terhubung',
        mapping_required: 'Company perlu dicek',
        not_found: 'Company belum diatur',
        invalid: 'Pengecekan CRM gagal',
        unchecked: 'Belum dicek',
    },
    chooseFromCrm: 'Pilih dari CRM',
    hideCrmPicker: 'Tutup pencarian CRM',
    checkCompanies: 'Cek company ke CRM',
    checkingCompanies: 'Memeriksa…',
    companiesChecked: 'Pengecekan company selesai.',
    checkCompaniesFailed: 'Pengecekan company belum selesai. Coba lagi.',
    flavorChecks: {
        flavorName: 'Nama flavor: diawali huruf kecil, lalu huruf, angka, atau garis bawah.',
        applicationName: 'Nama aplikasi wajib diisi, tanpa tanda kutip, backslash, atau $.',
        packageName: 'Package name harus berbentuk id.co.sekolah.app.',
        versionCode: 'Version code harus bilangan bulat mulai dari 1.',
        versionName: 'Version name: huruf, angka, titik, strip, atau garis bawah.',
        primary: 'Warna utama harus berformat #RRGGBB.',
        secondary: 'Warna sekunder harus berformat #RRGGBB.',
        serverKey: 'Server key harus 1 sampai 3 digit.',
        keystoreName: 'Nama keystore: huruf, angka, titik, strip, atau garis bawah.',
        keyAlias: 'Key alias: huruf, angka, titik, strip, atau garis bawah.',
        password: 'Password wajib diisi dan tidak boleh memuat tanda kutip, backslash, atau $.',
    },
    flavorChecksTitle: 'Perbaiki ini sebelum menyimpan:',
};

const lifecycleStrings = { en, id };

export default lifecycleStrings;
